import React from "react";
import { useNavigate } from "react-router";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { EXTERNAL_REGISTER_LANDING_DESTINATIONS } from "./externalRegisterRoutes";

export function ExternalRegisterLandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{ height: "100%", width: "100%", overflow: "auto", p: 3 }}>
      <Stack spacing={2.5} sx={{ maxWidth: 1180 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            {t("externalRegister.landing.title")}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 760 }}>
            {t("externalRegister.landing.description")}
          </Typography>
        </Box>

        <Alert severity="info" variant="outlined">
          {t("externalRegister.landing.alert")}
        </Alert>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "repeat(3, minmax(0, 1fr))",
            },
            gap: 2,
          }}
        >
          {EXTERNAL_REGISTER_LANDING_DESTINATIONS.map((destination) => (
            <Card key={destination.key} variant="outlined" sx={{ borderRadius: 1 }}>
              <CardContent>
                <Stack spacing={1.5} sx={{ minHeight: 190 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>
                      {t(destination.labelKey)}
                    </Typography>
                    {destination.statusKey ? <Chip size="small" variant="outlined" label={t(destination.statusKey)} /> : null}
                  </Stack>
                  <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
                    {destination.landingDescriptionKey ? t(destination.landingDescriptionKey) : ""}
                  </Typography>
                  <Button variant="contained" onClick={() => navigate(destination.settingsPath)}>
                    {t("externalRegister.landing.buttons.open")}
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Stack>
    </Box>
  );
}

export default ExternalRegisterLandingPage;
